"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    getGiftCardList: ()=>getGiftCardList,
    getGiftCard: ()=>getGiftCard,
    getGiftCardLocationList: ()=>getGiftCardLocationList,
    checkGiftCardBalance: ()=>checkGiftCardBalance,
    createGiftCard: ()=>createGiftCard,
    activateGiftCardWithPoints: ()=>activateGiftCardWithPoints,
    activateGiftCard: ()=>activateGiftCard,
    createGiftCardWithPoints: ()=>createGiftCardWithPoints,
    reloadGiftCard: ()=>reloadGiftCard,
    updateGiftCard: ()=>updateGiftCard,
    updateGiftCardBalances: ()=>updateGiftCardBalances,
    pointsToCashGiftCard: ()=>pointsToCashGiftCard,
    getGiftCardPaymentList: ()=>getGiftCardPaymentList,
    createGiftCardPayment: ()=>createGiftCardPayment,
    deleteGiftCardPayment: ()=>deleteGiftCardPayment,
    getLocationList: ()=>getLocationList,
    getPointToCash: ()=>getPointToCash,
    getRecievedGiftCard: ()=>getRecievedGiftCard,
    getGiftCardTransactions: ()=>getGiftCardTransactions,
    deleteGiftCards: ()=>deleteGiftCards,
    useRecievedGiftCard: ()=>useRecievedGiftCard,
    useGetGiftCardList: ()=>useGetGiftCardList,
    useGetGiftCard: ()=>useGetGiftCard,
    useGetGiftCardTransactions: ()=>useGetGiftCardTransactions,
    useGetPointToCash: ()=>useGetPointToCash,
    useGetGiftCardLocationList: ()=>useGetGiftCardLocationList,
    useGetGiftCardPaymentList: ()=>useGetGiftCardPaymentList,
    useLocationListQuery: ()=>useLocationListQuery,
    useCheckGiftCardBalance: ()=>useCheckGiftCardBalance,
    useCreateGiftCard: ()=>useCreateGiftCard,
    useCreateGiftCardWithPoints: ()=>useCreateGiftCardWithPoints,
    useActivateGiftCard: ()=>useActivateGiftCard,
    useActivateGiftCardWithPoints: ()=>useActivateGiftCardWithPoints,
    useReloadGiftCard: ()=>useReloadGiftCard,
    useUpdateGiftCard: ()=>useUpdateGiftCard,
    useDeleteGiftCards: ()=>useDeleteGiftCards,
    useUpdateGiftCardBalances: ()=>useUpdateGiftCardBalances,
    usePointsToCashGiftCard: ()=>usePointsToCashGiftCard,
    useCreateGiftCardPayment: ()=>useCreateGiftCardPayment,
    useDeleteGiftCardPayment: ()=>useDeleteGiftCardPayment,
    useTransactionsMobile: ()=>useTransactionsMobile,
    useTransactions: ()=>useTransactions,
    useTransactionDetails: ()=>useTransactionDetails
});
const _reactQuery = require("react-query");
const _index = require("./../../index");
const _react = require("react");
const _dateFns = require("date-fns");
// eslint-disable-next-line @typescript-eslint/no-empty-function
const emptyObj = {
    data: [],
    refetch: ()=>{},
    isLoading: true
};
const getGiftCardList = async (payload, opts)=>{
    if (!payload?.member_id) {
        return [];
    }
    const response = await _index.api.get(`/native_app/v2/gift_cards?member_id=${payload.member_id}`, opts);
    return response;
};
const getGiftCard = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_cards/${payload.id}?member_id=${payload.member_id}`, opts);
    return response.gift_card;
};
const getGiftCardLocationList = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_cards/location_list?member_id=${payload.member_id}`, opts);
    return response.location_list;
};
const checkGiftCardBalance = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_cards/check_balance?card_number=${payload.card_number}&card_pin=${payload.card_pin}&member_id=${payload.member_id}`, opts);
    return response.balance;
};
const createGiftCard = async (payload, opts)=>{
    // const cardBalance = payload.balance || await checkGiftCardBalance({ card_number: payload.card_number, card_pin: payload.card_pin, member_id: payload.member_id });
    // const balance = parseFloat(cardBalance.replace(/\$/g, ''));
    //
    // if (balance && !Number.isNaN(balance)) {
    //     const response: CreateGiftCardResponse = await api.post(`/native_app/v2/gift_cards?member_id=${payload.member_id}`, { ...payload, balance }, opts);
    //     return response.gift_card;
    // }
    return null;
};
const activateGiftCardWithPoints = async (payload, opts)=>{
    await _index.api.post(`/native_app/v2/gift_cards/activate_with_points?member_id=${payload.member_id}`, {
        ...payload
    }, opts);
};
const activateGiftCard = async (payload, opts)=>{
    return null;
// const response: ActivateGiftCardResponse = await api.post(`/native_app/v2/gift_cards/activate?member_id=${payload.member_id}`, payload, opts);
// return response.gift_card;
};
const createGiftCardWithPoints = async (payload, opts)=>{
    await _index.api.post(`/native_app/v2/gift_cards/create_with_points?member_id=${payload.member_id}`, payload, opts);
};
const reloadGiftCard = async (payload, opts)=>{
    return null;
// const response: ReloadGiftCardResponse = await api.post(`/native_app/v2/gift_cards/reload?member_id=${payload.member_id}`, payload, opts);
// return response.gift_card;
};
const updateGiftCard = async (payload, opts)=>{
    const response = await _index.api.put(`/native_app/v2/gift_cards/${payload.id}?member_id=${payload.member_id}`, payload, opts);
    return response.gift_card;
};
const updateGiftCardBalances = async (payload, opts)=>{
    const response = await _index.api.put(`/native_app/v2/gift_cards/update_gift_cards_balances?member_id=${payload.member_id}`, opts);
    return response;
};
const pointsToCashGiftCard = async (payload, opts)=>{
    const response = await _index.api.put(`/native_app/v2/gift_cards/points_to_cash?member_id=${payload.member_id}`, payload, opts);
    return response.gift_card;
};
const getGiftCardPaymentList = async (payload, opts)=>{
    if (!payload?.member_id) {
        return [];
    }
    const response = await _index.api.get(`/native_app/v2/gift_card_payments?member_id=${payload.member_id}`, opts);
    return response;
};
const createGiftCardPayment = async (payload, opts)=>{
    const response = await _index.api.post(`/native_app/v2/gift_card_payments?member_id=${payload.member_id}`, payload, opts);
    return response.payment;
};
const deleteGiftCardPayment = async (payload, opts)=>{
    const response = await _index.api.patch(`/native_app/v2/gift_card_payments/soft_delete?member_id=${payload.member_id}`, payload, opts);
    return response.payment;
};
const getLocationList = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_cards/location_list?member_id=${payload.member_id}`, opts);
    return response;
};
const getPointToCash = async (payload, opts)=>{
    const response = await _index.api.get(`/native_app/v2/gift_cards/points_to_cash?member_id=${payload.member_id}`, opts);
    return response;
};
const getRecievedGiftCard = async (payload, opts)=>{
    const response = await _index.api.get(`native_app/v2/gift_cards/received_list?member_id=${payload.member_id}`, opts);
    return response;
};
const getGiftCardTransactions = async (payload, opts)=>{
    let url = 'native_app/v2/gift_card_transactions';
    if (payload.transaction_id) {
        url = url + `/${payload.transaction_id}`;
    }
    url += `?member_id=${payload.member_id}&gift_card_id=${payload.gift_card_id}&page=${payload.page || 1}`;
    const response = await _index.api.get(url, opts);
    return response;
};
const deleteGiftCards = async (payload, opts)=>{
    const response = await _index.api.delete(`native_app/v2/gift_cards/destroy_all_depleted?member_id=${payload.member_id}`, opts);
    return response;
};
const useRecievedGiftCard = (queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('giftCard', ({ signal  })=>getRecievedGiftCard(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useGetGiftCardList = (queryOptions = {})=>{
    const { member , setGiftCards , setReceivedGiftCard  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    return (0, _reactQuery.useQuery)('giftCardList', ({ signal  })=>getGiftCardList(payload, {
            signal
        }), {
        ...queryOptions,
        enabled: !!payload,
        onSuccess: (data)=>{
            setGiftCards((previousState)=>{
                setReceivedGiftCard(previousState.length !== 0 && previousState.length < data.length);
                return data;
            });
        }
    });
};
const useGetGiftCard = (id, queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString(),
        id
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('giftCard', ({ signal  })=>getGiftCard(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useGetGiftCardTransactions = (id, queryOptions = {})=>{
    const { member , walletId  } = (0, _index.useSpringBigStore)();
    const payload = member && walletId && {
        member_id: walletId,
        gift_card_id: id
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('giftCard', ({ signal  })=>getGiftCardTransactions(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useGetPointToCash = (queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('pointToCash', ({ signal  })=>getPointToCash(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useGetGiftCardLocationList = (queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('giftCardLocationList', ({ signal  })=>getGiftCardLocationList(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useGetGiftCardPaymentList = (queryOptions = {})=>{
    const { member , setGiftCardPaymentList  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    return (0, _reactQuery.useQuery)('giftCardPaymentList', ({ signal  })=>getGiftCardPaymentList(payload, {
            signal
        }), {
        ...queryOptions,
        enabled: !!payload,
        onSuccess: (data)=>{
            setGiftCardPaymentList(data);
        }
    });
};
const useLocationListQuery = (queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString()
    };
    if (!payload) {
        return emptyObj;
    }
    return (0, _reactQuery.useQuery)('locationList', ({ signal  })=>getLocationList(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useCheckGiftCardBalance = (card_number, card_pin, queryOptions = {})=>{
    const { member  } = (0, _index.useSpringBigStore)();
    const payload = member && {
        member_id: member?.id.toString(),
        card_number,
        card_pin
    };
    if (!payload || !card_number || !card_pin) {
        return {
            data: '',
            refetch: ()=>{}
        };
    }
    return (0, _reactQuery.useQuery)('checkGiftCardBalance', ({ signal  })=>checkGiftCardBalance(payload, {
            signal
        }), {
        ...queryOptions
    });
};
const useCreateGiftCard = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>createGiftCard(payload), {
        ...queryOptions
    });
};
const useCreateGiftCardWithPoints = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>createGiftCardWithPoints(payload), {
        ...queryOptions
    });
};
const useActivateGiftCard = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>activateGiftCard(payload), {
        ...queryOptions
    });
};
const useActivateGiftCardWithPoints = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>activateGiftCardWithPoints(payload), {
        ...queryOptions
    });
};
const useReloadGiftCard = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>reloadGiftCard(payload), {
        ...queryOptions
    });
};
const useUpdateGiftCard = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>updateGiftCard(payload), {
        ...queryOptions
    });
};
const useDeleteGiftCards = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>deleteGiftCards(payload), {
        ...queryOptions
    });
};
const useUpdateGiftCardBalances = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>updateGiftCardBalances(payload), {
        ...queryOptions
    });
};
const usePointsToCashGiftCard = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>pointsToCashGiftCard(payload), {
        ...queryOptions
    });
};
const useCreateGiftCardPayment = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>createGiftCardPayment(payload), {
        ...queryOptions,
        onSuccess: (data)=>{
            console.log(data, 'THIS IS CREATe GIFT CARD PAYMENT');
        }
    });
};
const useDeleteGiftCardPayment = (queryOptions = {})=>{
    return (0, _reactQuery.useMutation)((payload)=>deleteGiftCardPayment(payload), {
        ...queryOptions,
        onSuccess: (data)=>{
            console.log(data, 'THIS IS DELETE GIFT CARD PAYMENT');
        }
    });
};
const useTransactionsMobile = (gift_card_id, wallet_id)=>{
    const [giftCardTransactions, setGiftCardTransactions] = (0, _react.useState)();
    const [page, setPage] = (0, _react.useState)(1);
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const onNextPress = ()=>{
        if (page) {
            setPage((prev)=>prev + 1);
        }
    };
    const onPrevPress = ()=>{
        if (page) {
            setPage((prev)=>prev - 1);
        }
    };
    (0, _react.useEffect)(()=>{
        (async ()=>{
            if (gift_card_id && page) {
                setIsLoading(true);
                const response = await getGiftCardTransactions({
                    gift_card_id: gift_card_id,
                    member_id: wallet_id,
                    page: page
                });
                response && setGiftCardTransactions(response);
                setIsLoading(false);
            }
        })();
    }, [
        gift_card_id,
        page
    ]);
    return {
        isLoading,
        giftCardTransactions,
        onNextPress,
        onPrevPress,
        page
    };
};
const useTransactions = (params, navigate, pageParam)=>{
    const [giftCardTransactions, setGiftCardTransactions] = (0, _react.useState)();
    const [page, setPage] = (0, _react.useState)();
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const updatePageParam = (page, state)=>{
        const searchParams = new URLSearchParams(location.search);
        searchParams.set('page', page.toString());
        navigate({
            pathname: location.pathname,
            search: searchParams.toString()
        }, {
            state: state
        });
    };
    const onNextPress = (state)=>{
        if (page) {
            updatePageParam(page + 1, state);
            setPage((prev)=>prev || 0 + 1);
        }
    };
    const onPrevPress = (state)=>{
        if (page) {
            updatePageParam(page - 1, state);
            setPage((prev)=>prev || 0 - 1);
        }
    };
    (0, _react.useEffect)(()=>{
        (async ()=>{
            if (params && params.gift_card_id && params.wallet_id && page) {
                setIsLoading(true);
                const response = await getGiftCardTransactions({
                    gift_card_id: params.gift_card_id,
                    member_id: params.wallet_id,
                    page: page
                });
                response && setGiftCardTransactions(response);
                setIsLoading(false);
            }
        })();
    }, [
        params.gift_card_id,
        page
    ]);
    (0, _react.useEffect)(()=>{
        setPage(parseInt(pageParam) || 1);
    }, [
        pageParam
    ]);
    return {
        isLoading,
        giftCardTransactions,
        onNextPress,
        onPrevPress
    };
};
const useTransactionDetails = (params, transaction)=>{
    const { giftCards , giftCardPaymentList  } = (0, _index.useSpringBigStore)();
    const { refetch: giftCardListQuery , isLoading: isGiftCardLoading  } = useGetGiftCardList();
    const { refetch: refetchPaymentCardDetails , isLoading: paymentCardsLoading  } = useGetGiftCardPaymentList();
    const [giftCardTransaction, setGiftCardTransaction] = (0, _react.useState)();
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const [giftCardNumber, setGiftCardNumber] = (0, _react.useState)();
    const [paymentCard, setPaymentCard] = (0, _react.useState)();
    const { t  } = (0, _index.useI18n)();
    (0, _react.useEffect)(()=>{
        if (!giftCardPaymentList || !paymentCardsLoading) {
            refetchPaymentCardDetails();
        }
    }, []);
    (0, _react.useEffect)(()=>{
        if (giftCardPaymentList && giftCardPaymentList.length > 0) {
            const filteredPaymentCard = giftCardPaymentList.filter((card)=>card.id === transaction.gift_card_payment_id);
            filteredPaymentCard && filteredPaymentCard.length > 0 && setPaymentCard(filteredPaymentCard[0].account_name || filteredPaymentCard[0].card_nickname);
        } else if (!giftCardPaymentList && !paymentCardsLoading) {
            refetchPaymentCardDetails();
        }
    }, [
        giftCardPaymentList,
        transaction
    ]);
    (0, _react.useEffect)(()=>{
        if (params.gift_card_id && giftCards && giftCards.length > 0 && !isGiftCardLoading) {
            const selectedGiftCard = giftCards.length > 0 && giftCards.filter((giftCard)=>giftCard.id.toString() === params.gift_card_id);
            selectedGiftCard && selectedGiftCard.length > 0 && setGiftCardNumber(selectedGiftCard[0].card_number);
        } else if ((!giftCards || giftCards.length === 0) && !isGiftCardLoading) {
            giftCardListQuery();
        }
    }, [
        giftCards
    ]);
    (0, _react.useEffect)(()=>{
        (async ()=>{
            if (params && params.gift_card_id && params.wallet_id && params.transaction_id && !transaction.id) {
                setIsLoading(true);
                const response = await getGiftCardTransactions({
                    gift_card_id: params.gift_card_id,
                    member_id: params.wallet_id,
                    transaction_id: params.transaction_id
                });
                response && response.transactions.length > 0 && setGiftCardTransaction(response.transactions[0]);
                setIsLoading(false);
            } else if (transaction.id) {
                transaction && setGiftCardTransaction(transaction);
            }
        })();
    }, [
        params.gift_card_id,
        params.transaction_id,
        transaction
    ]);
    const transactionRecords = (0, _react.useMemo)(()=>{
        if (!giftCardTransaction) {
            return {};
        }
        const isCardPayment = transaction.payment_provider === 'nmi';
        const referenceId = transaction?.gift_card_payment_id?.toString() || transaction.reward_redemption_id?.toString() || '-';
        return {
            date: (0, _dateFns.format)(new Date(transaction.created_at), 'dd-MM-yyyy'),
            status: transaction.status,
            provider: transaction.payment_provider,
            type: t(`giftCard.transactions.details.${transaction.payment_provider}`),
            referenceId,
            fee: isCardPayment ? transaction.process_fee : '-',
            total: isCardPayment ? ((transaction.load_amount_cents || 0) / 100 + (parseFloat(transaction.process_fee) || 0)).toFixed(2).toString() : '-',
            currency: transaction.load_amount_currency,
            last4digit: transaction.four_digits ? `x${transaction.four_digits.toString()}` : '-',
            providerId: isCardPayment && transaction.nmi_transaction_id ? transaction.nmi_transaction_id : '-',
            loadAmount: (transaction.load_amount_cents / 100).toFixed(2).toString(),
            pointsRedeemed: 'points redeemed',
            giftCardDigits: giftCardNumber ? `x${giftCardNumber.slice(-4)}` : '-'
        };
    }, [
        giftCardTransaction,
        giftCardNumber,
        paymentCard
    ]);
    return {
        isLoading,
        transactionRecords
    };
};
